import gql from 'graphql-tag'

export const ticketAlertFragment = gql`
  fragment ticketAlert on TicketAlert {
    id
    event {
      id
      name
      wantedListingsCount
      isPopular
      types(first: 99) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
    eventType {
      id
      title
      wantedListingsCount
      isPopular
    }
    maximumPrice {
      amount
      currency
    }
  }
`
